import "../../styles/styles.scss";
import TableDynamic from "../../components/TableDynamic";
import React from "react";
import ApiService from "../../services/ApiService";
import { store } from "../../reducer/Store";

const AdminClient = () => {
  const { dispatch, state } = React.useContext(store);
  const columnsName = ["Code tiers", "Nom", "Groupement", "Statut", "Actif"];
  const columns = ["id", "name", "group", "status", "active_customers"];
  const [noResultMessage, setNoResultMessage] = React.useState(false);

  /**
   * Cette fonction récupère la liste des clients de l'application avec une pagination, une recherche par mot-clé peut être effectuée en précisant un paramètre de recherche.
   * @param { Number } page - La page à récupérer, par défaut 1.
   * @param { Number } max - Le nombre maximal d'éléments à retourner par page, par défaut 25.
   * @param { String } search - Un mot-clé à rechercher chez les clients, par défaut une chaîne vide.
   */
  const getCustomers = async (page = 1, max = 25, search = "") => {
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {},
      "customers-paginated?page=" + page + "&max=" + max,
      "get"
    )
      .then(function (response) {
        search && search.length >= 3
          ? searchCustomers(search, page, max)
          : dispatch({
              type: "SET_DATACUSTOMERSADMIN",
              payload: response.data,
            });
        dispatch({ type: "SET_LOADER", payload: false });
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction met à jour l'état d'un client en activant ou désactivant son compte.
   * @param { Object } customer - Le client à mettre à jour.
   * @param { Number } currentPage - La page courante de la liste de clients.
   * @param { Number } max - Le nombre maximal d'éléments à retourner par page.
   * @param { String } search - Un mot-clé à rechercher chez les clients.
   */
  const updateCustomerState = async (customer, currentPage, max, search) => {
    if (
      window.confirm(
        "Etes vous sûr de vouloir désactiver le client " + customer.name + "?"
      )
    ) {
      dispatch({ type: "SET_LOADER", payload: true });
      ApiService.request(
        { active: customer.active === 0 ? 1 : 0 },
        "customer-active/" + customer.id,
        "put"
      )
        .then(function () {
          search.length >= 3
            ? searchCustomers(search, currentPage, max)
            : getCustomers(currentPage, max);

          dispatch({ type: "SET_LOADER", payload: false });
        })
        .catch(function (error) {
          dispatch({ type: "SET_LOADER", payload: false });
          if (error.response.data.message === "Unauthenticated.") {
            localStorage.clear();
            dispatch({ type: "SET_LOGOUT", payload: false });
          }
        });
    }
  };

  /**
   * Cette fonction recherche les clients de l'application correspondant à un mot-clé donné, avec une pagination.
   * @param {String} search - Le mot-clé à rechercher chez les clients.
   * @param {Number} page - La page à récupérer, par défaut 1.
   * @param {Number} max - Le nombre maximal d'éléments à retourner par page, par défaut 25.
   */
  const searchCustomers = (search, page = 1, max = 25) => {
    dispatch({ type: "SET_LOADER", payload: true });
    setNoResultMessage(false);
    ApiService.request(
      { search, page, max },
      "customers-search-paginated",
      "post"
    )
      .then(function (response) {
        if (response.message === "No result.") {
          setNoResultMessage(true);
        } else {
          dispatch({
            type: "SET_DATACUSTOMERSADMIN",
            payload: response.data,
          });
        }
        dispatch({ type: "SET_LOADER", payload: false });
      })
      .catch(function (error) {
        // manque un message quand c'est une error
        dispatch({ type: "SET_LOADER", payload: false });
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
        console.log(error);
      });
  };

  React.useEffect(() => {
    getCustomers();
  }, []);

  return (
    <>
      <h1>Clients</h1>
      <TableDynamic
        controlTableId="customers"
        columnsName={columnsName}
        columns={columns}
        data={state.dataCustomersAdmin.data}
        getDataPagination={getCustomers}
        dataPagination={state.dataCustomersAdmin}
        updateState={updateCustomerState}
        search={searchCustomers}
        setNoResultMessage={setNoResultMessage}
        noResultMessage={noResultMessage}
      ></TableDynamic>
    </>
  );
};
export default AdminClient;
